// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xYot","textarea":"styles_textarea__38Oz8"};